import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSelector = ({ compact = false, className = "" }) => {
  const { t, i18n } = useTranslation();
  const changeLanguage = (e) => {
    const lang = e.target.value;
    i18n.changeLanguage(lang);
    localStorage.setItem('language', lang);
    document.documentElement.lang = lang;
  };
  const value = (i18n.resolvedLanguage || i18n.language || 'en').split('-')[0];

  return (
    <select
      onChange={changeLanguage}
      value={value}
      aria-label={t('language')}
      title={t('language')}
      className={`h-9 rounded-lg border bg-white px-3 control-text text-gray-800 shadow-sm ${compact ? "w-[4.75rem]" : "min-w-36"} ${className}`}
    >
      <option value="en">{compact ? "EN" : t('english')}</option>
      <option value="vi">{compact ? "VI" : t('vietnamese')}</option>
    </select>
  );
};

export default LanguageSelector;
